import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Tabs = ({ tabs, onTabChange, className = '', pathTabsName, resetTrigger, blackTab, indexTabchange }) => {
    const [active, setActive] = useState(tabs.findIndex((tab) => tab.isActive));
    const location = useLocation();

    useEffect(() => {
        if (pathTabsName) {
            setActive(tabs.findIndex((tab) => tab.isActive));
        }
    }, [tabs, pathTabsName]);

    const handleTabClick = (index) => {
        if (React.isValidElement(tabs[index].label)) {
            return;
        }
        setActive(index);
        if (onTabChange) {
            onTabChange(index);
        }
    };

    useEffect(() => {
        if (resetTrigger) {
            setActive(-1);
        }
    }, [resetTrigger]);

    useEffect(() => {
        if (indexTabchange !== undefined) {
            setActive(indexTabchange);
        }
    }, [indexTabchange]);

    return (
        <ul className={`tabs ${className}`}>
            {tabs.map((tab, index) => {
                let params;
                if (pathTabsName) {
                    params = new URLSearchParams(location.search);
                    params.set('tab', index + 1);
                }
                return (
                    <li key={index}>
                        <Link
                            to={
                                pathTabsName
                                    ? `${location.pathname}?${params.toString()}`
                                    : location.pathname + location.search
                            }
                            className={`${active === index ? 'active' : ''} ${
                                React.isValidElement(tab.label) ? 'tab-search' : ''
                            } ${blackTab ? 'black' : ''}`}
                            onClick={() => handleTabClick(index)}
                        >
                            {tab.icon && <i className={`icon ${tab.icon}`} />}
                            {typeof tab.label === 'string' ? tab.label : tab.label}
                        </Link>
                    </li>
                );
            })}
        </ul>
    );
};

export default Tabs;
